module.exports = __webpack_public_path__ + "static/design-denim.83c20878.svg";